/**
 * Vero se l'asset di una consegna è ancora da spedire. Ha già un DDT di consegna solo se
 * `related_ddt_id` è valorizzato e non è il DDT di un trasferimento tra magazzini: un trasferimento
 * lascia il suo DDT sull'asset, che però è in magazzino e va spedito normalmente.
 */
export function isAssetToShip(am: {
  related_ddt_id?: number | null;
  related_ddt_is_transfer?: boolean | null;
}): boolean {
  return !am.related_ddt_id || !!am.related_ddt_is_transfer;
}
